import React from "react";
import { STATS, REASONS } from "@/lib/site";

export const WhyChooseUs = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 md:py-32 bg-brand-surface border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-brand-gold/90">
              <span className="inline-block h-px w-10 bg-brand-gold" />
              Why Renderwall
            </div>
            <h2 className="mt-4 font-serif text-4xl md:text-5xl text-white leading-tight text-balance">
              A trade business built on{" "}
              <span className="text-brand-gold italic">trust</span>, not
              just turnover.
            </h2>
            <p className="mt-6 text-white/70 text-base md:text-lg leading-relaxed">
              We&apos;re a small, hands-on team. The person quoting your job is the
              person on the tools. That means sharper pricing, better detail
              and one accountable phone number from start to finish.
            </p>

            <div className="mt-10 grid grid-cols-2 gap-6">
              {STATS.map((s) => (
                <div
                  key={s.label}
                  data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="border-l-2 border-brand-gold pl-4"
                >
                  <div className="font-serif text-4xl md:text-5xl text-white leading-none">
                    {s.value}
                  </div>
                  <div className="mt-2 text-xs uppercase tracking-[0.18em] text-white/60">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4 md:gap-6">
            {REASONS.map((r, i) => (
              <div
                key={r.title}
                data-testid={`reason-card-${i}`}
                className="bg-brand-card p-7 md:p-8 border-l-2 border-brand-gold/60 hover:border-brand-gold transition-colors duration-300"
              >
                <div className="font-serif text-xl md:text-2xl text-white">
                  {r.title}
                </div>
                <p className="mt-3 text-white/70 leading-relaxed">{r.body}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
